import log from 'loglevel';
import io from 'socket.io-client';

export default function (socketUrl, customData, path, options) {
    const socket = io(socketUrl, {
        path,
        ...options,
        query: {
            ...(options?.query || {}),
            ...(customData?.bot ? { bot: customData.bot } : {}),
            ...(customData?.partnerId ? { partner: customData.partnerId } : {}),
        },
    });

    socket.on('connect', () => {
        log.debug(`connect:${socket.id}`);
        socket.customData = customData;
    });

    socket.on('connect_error', (error) => {
        log.info(error);
    });

    socket.on('disconnect', (reason) => {
        log.debug(reason);
    });

    return socket;
}
